
export default {
  render(h) {
    return h();
  } // render
}; // export default
